import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Popup } from '../../../common/popup';
import { DateHelper } from '../../../helpers/DateHelper';
import { StockLabel } from '../stock-label';
import { ActionButtonContainer } from '../action-button-container/ActionButtonContainer';
import { ProductStore } from '../stores/ProductStore';
import { FAQStore } from '../stores/FAQStore';
import { CompareCheckbox } from '../../../common/compare-checkbox';
import styles from './ProductDescriptor.css';

const IPropTypes = {
  className: PropTypes.string,
  onScrollToFAQ: PropTypes.func,
  onSeeAllFinancingPlans: PropTypes.func,
};

const defaultProps = {
  className: '',
  onScrollToFAQ: () => {},
  onSeeAllFinancingPlans: () => {},
};

const renderFinancingBullets = financing => (
  financing.zeroDayExpiry.map(item => (
    <tr key={`${item.amount}-${item.price}`}>
      <td>
        <p className={styles.financingBullet}>
          ${item.priceString}
        </p>
      </td>
      <td>
        <p className={styles.financingBullet}>
          x
        </p>
      </td>
      <td>
        <p className={styles.financingBullet}>
          {item.amount} cuotas
        </p>
      </td>
      <td>
        <Popup
          className={styles.financingBulletPopup}
          text="PTF"
          textClass={styles.financingBulletTotalPrice}
        >
          <p className={styles.popupText}>
            Precio total financiado
          </p>
          <p className={styles.financingBulletPriceValue}>
            ${item.totalPriceString}
          </p>
        </Popup>
      </td>
    </tr>
  ))
);

const ProductDescriptor = (props) => {
  const { product } = ProductStore;
  return (
    <div className={props.className}>
      <div className={styles.topSection}>
        <p className={styles.brand}>
          {product.brand}
        </p>
        <h2 className={styles.name}>
          {product.name}
        </h2>
        {
          !product.isService &&
          <div className={styles.stockContainer}>
            <StockLabel product={product} />
            <p className={styles.stockLastUpdate}>
              Actualizado {DateHelper.toTimeLocalizedString(product.stockLevelLastUpdate)}
            </p>
          </div>
        }
        {
          product.isService &&
          <p className={styles.serviceText}>
            {product.serviceAvailabilityText}
          </p>
        }
        {
          FAQStore.numberOfQuestions > 0 &&
          <button
            className={styles.questionAmount}
            onClick={props.onScrollToFAQ}
          >
            » {FAQStore.numberOfQuestions} pregunta{FAQStore.numberOfQuestions !== 1 ? 's ' : ' '}
            respondida{FAQStore.numberOfQuestions !== 1 ? 's' : ''}
          </button>
        }
      </div>
      <div className={styles.bottomSection}>
        {
          product.shouldShowPrice() &&
          <div className={styles.priceContainer}>
            <h2 className={styles.price}>
              ${product.financing.priceString}
            </h2>
            <p className={styles.priceSubtext}>Contado</p>
          </div>
        }
        {
          !product.shouldShowPrice() &&
          <p className={styles.undefinedPrice}>Precio sin determinar</p>
        }
        { (product.ableToSell || product.stockIsEmpty()) &&
          <div>
            <table className={styles.financingBulletContainer}>
              <tbody>
                {renderFinancingBullets(product.financing)}
              </tbody>
            </table>
            <p className={styles.genericSubtext}>
              Crédito disponible sólo en nuestros locales.
            </p>
            <button
              className={styles.financingLink}
              onClick={props.onSeeAllFinancingPlans}
            >
              Ver todos los planes financiados ▾
            </button>
          </div>
        }
        <ActionButtonContainer product={product} />
        <CompareCheckbox product={product} />
      </div>
    </div>
  );
};

ProductDescriptor.propTypes = IPropTypes;
ProductDescriptor.defaultProps = defaultProps;

const ObservedProductDescriptor = observer(ProductDescriptor);

export { ObservedProductDescriptor as ProductDescriptor };



// WEBPACK FOOTER //
// ./src/pages/product-detail/product-descriptor/ProductDescriptor.jsx